import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
  standalone: false,
})
export class ToggleButtonComponent {
  @ViewChild('inputBox', { read: ElementRef })
  inputBox: ElementRef<HTMLElement>;
  @Input() isChecked: boolean = false;
  @Output() changed = new EventEmitter<boolean>();

  onChange(event: any) {
    if (event && event.target) {
      this.isChecked = (<HTMLInputElement>event.target).checked;
      this.changed.emit(this.isChecked);
    }
  }
}
